module.exports = __webpack_public_path__ + "img/information.e502666e.svg";